import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import { Slide, toast } from "react-toastify";
import { Tooltip, IconButton, Modal, Box, Autocomplete } from "@mui/material";
import "../../../../style/setup.css";

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 14,
  padding: "5px 10px",
  border: "1px solid",
  width: "fit-content",
  height: "100%",
  lineHeight: 1.5,
  backgroundColor: "#069DAE",
  fontFamily: ["Roboto"].join(","),
  "&:hover": {
    backgroundColor: "#0696A6",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc",
    borderColor: "#005cbf",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

function ModalCreateDistrict({
  refreshData,
  modalCreateDistrict,
  setModalCreateDistrict,
  provinceSelectedId,
  regencySelectedId,
  provinceName,
  setProvinceName,
  regencyName,
  setRegencyName,
}) {
  const accessToken = Cookies.get("access_token") || "";

  const [isLoading, setIsLoading] = useState(false);

  const [newData, setNewData] = useState({
    province_id: provinceSelectedId || "",
    regency_id: "",
    code: "",
    name: "",
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      if (modalCreateDistrict) {
        if (provinceSelectedId) {
          setNewData((prevData) => ({
            ...prevData,
            province_id: provinceSelectedId,
          }));
        }
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [accessToken, modalCreateDistrict]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (newData.province_id) {
        if (regencySelectedId) {
          setNewData((prevData) => ({
            ...prevData,
            regency_id: regencySelectedId,
          }));
        }
      }
    }, 200);
    return () => {
      clearTimeout(handler);
    };
  }, [newData.province_id]);

  const handleSetupInputChange = (event) => {
    const { name, value } = event.target;
    setNewData({
      ...newData,
      [name]: value,
    });
  };

  const handleCreateData = async () => {
    setIsLoading(true);
    const token = Cookies.get("access_token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/v1/district`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newData),
        }
      );

      if (response.status === 201) {
        toast.success("Data berhasil dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        refreshData();
        setModalCreateDistrict(false);
        setNewData({
          province_id: "",
          code: "",
          name: "",
          area: "",
        });
      } else if (response.status == 422) {
        toast.error("Data gagal diproses!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      } else {
        const data = await response.json();
        toast.error(data.detail || "Data gagal dibuat!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
      }
    } catch (error) {
      console.error("Error creating Data:", error);
    }
    setIsLoading(false);
  };

  return (
    <Modal
      open={modalCreateDistrict}
      onClose={() => {
        setModalCreateDistrict(false);
        setProvinceName("");
        setRegencyName("");
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ border: 0 }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: {
            xs: "90vw",
            sm: 400,
          },
          maxHeight: "90vh",
          bgcolor: "background.paper",
          border: "0px solid #000",
          boxShadow: 24,
          p: {
            xs: 2,
            sm: 4,
          },
          overflowY: "auto",
          borderRadius: 2,
        }}
      >
        <Tooltip title="Close Modal">
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => {
              setModalCreateDistrict(false);
              setNewData({
                province_id: "",
                regency_id: "",
                code: "",
                name: "",
              });
            }}
            sx={{ position: "absolute", top: 20, right: 30 }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <div className="create-data">
          <h2 style={{ marginBottom: "15px" }}>Create Kecamatan</h2>
          <div>
            <p>
              Provinsi : <span style={{ fontWeight: 700 }}>{provinceName}</span>
            </p>
          </div>
          <div>
            <p>
              Kab/Kota : <span style={{ fontWeight: 700 }}>{regencyName}</span>
            </p>
          </div>
          <div>
            <TextField
              label="KODE"
              name="code"
              value={newData.code}
              onChange={handleSetupInputChange}
              sx={{ width: "100%", mb: 2 }}
            />
          </div>
          <div>
            <TextField
              label="NAME"
              name="name"
              value={newData.name}
              onChange={handleSetupInputChange}
              sx={{ width: "100%", mb: 2 }}
            />
          </div>
          <div>
            <BootstrapButton
              variant="contained"
              disableRipple
              sx={{ width: "100%", mt: 2, height: 50, mb: 3 }}
              onClick={handleCreateData}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Submit"}
            </BootstrapButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalCreateDistrict;
